import { combineReducers } from 'redux'
// @ts-ignore
import { snackbarReducer as snackbarPlugin } from 'react-redux-snackbar'
import loginInReducer from '@App/reducers/loginInReducer'
import { reducer as reduxFormReducer } from 'redux-form'
import snackbarReducer from './snackbarReducer'
import rolesReducer from './rolesReducer'
import jobsReducer from './jobsReducer'
import networksReducer from './networksReducer'
import usersReducer from '@App/store/user/usersReducer'
import segmentsReducer from '@App/store/segment/segmentsReducer'
import organizationsReducer from '@App/store/organizations/reducers'
import applicationsReducer from '@App/store/application/reducers'
import ModalReducer from '@App/store/modal/reducers'
import toggleFieldsReducer from '@App/store/toggleField/reducers'

const rootReducer = combineReducers({
  snackbarReducer,
  form: reduxFormReducer,
  user: loginInReducer,
  roles: rolesReducer,
  jobs: jobsReducer,
  networks: networksReducer,
  snackbar: snackbarReducer,
  users: usersReducer,
  segments: segmentsReducer,
  organizations: organizationsReducer,
  applications: applicationsReducer,
  modal: ModalReducer,
  toggleFields: toggleFieldsReducer,
})

export default rootReducer

export type AppState = ReturnType<typeof rootReducer>
